import React from 'react';

/**
 * Experience component showcasing company expertise with dark animated theme
 */
const Experience = () => {
  return (
    <section className="experience-section-dark">
      <div className="experience-animated-bg">
        <div className="experience-orb experience-orb-1"></div>
        <div className="experience-orb experience-orb-2"></div>
        <div className="experience-orb experience-orb-3"></div>
      </div>

      <div className="experience-content">
        <div className="section-header">
          <h2>12 Years of Excellence</h2>
          <p>Transforming businesses through innovative technology solutions and proven expertise</p>
        </div>


        <div className="experience-description">
          <p>
            With over a decade of experience in the technology industry, we've mastered the art of
            creating solutions that truly work. Our deep expertise in CRM systems, AI automation,
            and modern web development enables us to deliver transformative results that drive
            business growth and operational excellence.
          </p>
          <p>
            We don't just build software – we engineer complete business solutions that evolve
            with your needs, ensuring long-term success and sustainable growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Experience;